import { useMessagesRepository } from '@Hooks/useRepository';
import { NotificationsRepository } from '@Repositories/Messages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useAcknowledgeAllNotifications() {
    const notifications = useMessagesRepository(NotificationsRepository);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => notifications.acknowledgeAll(),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
    });
}
